(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unisign-qr-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('uq2');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const screen = root.querySelector('#uq2-screen');
  const message = root.querySelector('#uq2-pixel-message');
  const buttons = Array.from(root.querySelectorAll('[data-usage]'));
  buttons.forEach(button => button.addEventListener('click', () => {
    const mode = button.dataset.usage;
    const template = root.querySelector('template[data-demo="' + mode + '"]');
    if (!template) return;
    screen.replaceChildren(template.content.cloneNode(true));
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    message.textContent = root.querySelector('[data-explanation="' + mode + '"]').textContent;
  }));
  const pixel = root.querySelector('.uq2-pixel');
  pixel.addEventListener('click', () => {
    const active = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
    buttons[(active + 1) % buttons.length].click();
  });
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && matchMedia('(pointer:fine)').matches) {
    const eyes = Array.from(pixel.querySelectorAll('[data-eye]'));
    root.addEventListener('pointermove', event => {
      const box = pixel.getBoundingClientRect();
      if (box.bottom < 0 || box.top > innerHeight) return;
      const dx = event.clientX - (box.left + box.width / 2);
      const dy = event.clientY - (box.top + box.height / 2);
      const length = Math.max(Math.hypot(dx,dy),1);
      eyes.forEach(eye => eye.setAttribute('transform','translate(' + (dx/length*1.4) + ' ' + (dy/length*1.1) + ')'));
    }, { passive: true });
    root.addEventListener('pointerleave', () => eyes.forEach(eye => eye.removeAttribute('transform')));
  }
})();
  } catch(e) { console.error(e); }
})();

})();
